<template>
  <div class="box">
    <el-drawer
      :visible.sync="visible"
      :wrapperClosable="false"
      :size="size"
      custom-class="drawer1"
      @close="cancelBtn"
    >
      <div slot="title" style="border-bottom:1px solid #ccc;padding-bottom:10px;">众筹救助申请信息</div>
      <el-card style="margin:0px 10px 50px;">
        <el-row>
          <el-col :span="6" class="left">
            <div class="avatar">
              <img
                v-if="baseInfo.info.header_pic && baseInfo.info.header_pic > 0"
                :src="baseInfo.info.header_pic_url"
                alt
                :onerror="onerrorDefaultImg"
              />

              <img v-else :src="defaultImg" title="救助申请默认头像" />
            </div>
            <div style="margin-top:20px" class="left-bottom">
              <p>
                出生日期：
                <span>{{baseInfo.info.birthday}}</span>
              </p>

              <p>
                年龄：
                <span>{{baseInfo.info.age}}</span>
              </p>

              <!-- <p>
                户口所在地：
                <span>{{baseInfo.info.domicile}}</span>
              </p>-->

              <p>
                籍贯：
                <span>{{baseInfo.info.jg}}</span>
              </p>

              <!-- <p v-if="baseInfo.info.wechat_no && baseInfo.info.wechat_no != ''">
                微信号：
                <span>{{baseInfo.info.wechat_no}}</span>
              </p>-->

              <p>
                家庭住址：
                <span>{{district}}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="18">
            <div style="margin-bottom:20px;">
              <h4>
                {{baseInfo.info.user_name}} [{{baseInfo.info.user_sex_text}}]
                <!-- <span
                  v-if="baseInfo.contract"
                  style="margin-left:10px"
                >
                  <el-tag
                    type="warning"
                    v-if="baseInfo.contract.foundagree == 0"
                    effect="dark"
                    size="small"
                  >待审核</el-tag>
                  <el-tag
                    type="success"
                    v-else-if="baseInfo.contract.foundagree == 1"
                    effect="dark"
                    size="small"
                  >已通过</el-tag>
                  <el-tag
                    type="danger"
                    v-else-if="baseInfo.contract.foundagree == 2"
                    effect="dark"
                    size="small"
                  >未通过</el-tag>
                </span>
                <span v-else>
                  <el-tag type="info" effect="dark" size="small">未申请</el-tag>
                </span>-->
              </h4>
              <p style="margin-top:15px">
                <span class="box-title">
                  <i class="el-icon-bank-card"></i>:
                </span>
                <span class="box-value">{{baseInfo.info.user_cardno}}</span>
                <span class="box-title" style="margin-left:15px">
                  <i class="el-icon-mobile-phone"></i>:
                </span>
                <span class="box-value">{{baseInfo.info.rela_phone}}</span>
              </p>
            </div>
            <el-tabs v-model="activeName" type="border-card" style="width:98%">
              <el-tab-pane label="救助信息" name="1">
                <el-card style="margin:10px;">
                  <div slot="header">
                    <p>
                      {{baseInfo.info.regtime}} 在 “
                      <span
                        style="color:red"
                      >{{baseInfo.info.project_name}}</span>” 项目的救助信息
                      <span style="float:right">
                        <span
                          v-if="baseInfo.opinion.audit_result == 0"
                          style="color:#e6a23c"
                        >{{baseInfo.opinion.audit_status_text}}</span>
                        <span
                          v-if="baseInfo.opinion.audit_result == 1"
                          style="color:green"
                        >{{baseInfo.opinion.audit_status_text}}</span>

                        <el-tooltip
                          class="item"
                          effect="light"
                          :content="baseInfo.opinion.audit_opinion"
                          v-if="baseInfo.opinion.audit_result == 2"
                          placement="bottom"
                        >
                          <span
                            style="color:red;text-decoration: underline;cursor: pointer;"
                          >{{baseInfo.opinion.audit_status_text}}</span>
                        </el-tooltip>
                      </span>
                    </p>
                  </div>

                  <div>
                    <!-- <el-collapse v-model="collapseActive" accordion>
                      <el-collapse-item name="1">
                        <template slot="title">
                          <p style="width:95%">
                            {{baseInfo.info.regtime}} 在 “
                            <span
                              style="color:red"
                            >{{baseInfo.info.project_name}}</span>” 项目的救助信息
                            <span style="float:right">{{baseInfo.info.audit_result_text}}</span>
                          </p>
                    </template>-->

                    <el-row
                      :gutter="20"
                      justify="center"
                      style="padding:10px 0px"
                      v-if="baseInfo.opinion.audit_result == 1"
                    >
                      <el-col :span="10">
                        <span class="box-title">拨款状态：</span>
                        <span
                          class="box-value"
                          style="text-decoration: underline;cursor: pointer;"
                          v-if="baseInfo.opinion.status"
                          @click="getPaymentDetail(baseInfo.opinion.pay_id,baseInfo.info.project_id,baseInfo.info.project_name)"
                        >{{ baseInfo.opinion.status_text }}</span>
                        <span class="box-value" v-else>{{baseInfo.opinion.status_text}}</span>
                        <span class="box-value" v-if="baseInfo.opinion.status">
                          <i class="el-icon-warning" size="18" style="clear: both;"></i>&nbsp;点击可查看此次拨款申请信息
                        </span>
                      </el-col>

                      <!-- <el-col :span="10" :offset="2">
                        <span class="box-title">审批金额：</span>
                        <span class="box-value" v-if="baseInfo.opinion.status == 1">{{ baseInfo.info.approve_amount }}</span>
                        <span class="box-value" v-else>{{ baseInfo.info.approve_amount }}</span>
                      </el-col>-->
                    </el-row>

                    <el-row :gutter="20" justify="center" style="padding:10px 0px">
                      <el-col :span="10">
                        <span class="box-title">项目负责人：</span>
                        <span class="box-value">{{ baseInfo.info.leader }}</span>
                      </el-col>
                      <el-col :span="10" :offset="2">
                        <span class="box-title">负责人电话：</span>
                        <span class="box-value">{{ baseInfo.info.leader_tel }}</span>
                      </el-col>
                    </el-row>

                    <el-row :gutter="20" justify="center" style="padding:10px 0px">
                      <el-col :span="10">
                        <span class="box-title">医保类型：</span>
                        <span class="box-value">{{ baseInfo.extend.ybbxlx_text }}</span>
                      </el-col>
                      <el-col :span="10" :offset="2">
                        <span class="box-title">家庭年收入：</span>
                        <span class="box-value">{{ baseInfo.info.family_year_income | setNumFormat}}</span>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" justify="center" style="padding:10px 0px">
                      <el-col :span="10">
                        <span class="box-title">入院日期：</span>
                        <span class="box-value">{{ baseInfo.extend.admission_time || '暂未填写' }}</span>
                      </el-col>
                      <el-col :span="10" :offset="2">
                        <span class="box-title">申请人类型：</span>
                        <span class="box-value">{{ apply_type_text}}</span>
                      </el-col>
                    </el-row>

                    <el-row :gutter="20" justify="center" style="padding:10px 0px">
                      <el-col :span="20">
                        <span class="box-title">备注：</span>
                        <span class="box-value">{{ baseInfo.info.remarks || "未填写" }}</span>
                      </el-col>
                    </el-row>

                    <el-row :gutter="20" justify="center" style="padding:10px 0px;">
                      <el-col :span="20">
                        <span class="box-title">贫困证件：</span>
                        <span
                          class="box-value"
                          v-if="baseInfo.poor_files_path && baseInfo.poor_files_path[0]"
                        >
                          <!-- <span
                            v-for="(item,index) in  baseInfo.poor_files_path"
                            :key="index"
                            @click="downFile(item.id, item.name)"
                            style="text-decoration: underline;cursor: pointer;color:#4682B4;margin-right:8px "
                          >{{item.name}}</span>-->
                          <a
                            style="margin-right:8px;"
                            :href="item.url"
                            v-for="(item,index) in  baseInfo.poor_files_path"
                            :key="index"
                            target="_blank"
                          >{{item.name}}</a>

                          <p style="clear: both; padding-top: 10px">
                            <i class="el-icon-warning" size="18" style="clear: both;"></i>&nbsp;点击文件名可进行下载
                          </p>
                        </span>
                        <span class="box-value" v-else>未上传~</span>
                      </el-col>
                    </el-row>

                    <el-row :gutter="20" justify="center" style="padding:10px 0px;">
                      <el-col :span="20">
                        <span class="box-title">眼疾情况：</span>
                        <span class="box-value">
                          <el-table
                            :data="baseInfo.eye"
                            border
                            style="width: 100%"
                            show-summary
                            :summary-method="getSummaries"
                          >
                            <el-table-column prop="eye_diseases_text" align="center" label="眼疾"></el-table-column>
                            <el-table-column prop="eys_esparation_text" align="center" label="眼别"></el-table-column>
                            <el-table-column prop="eye_money" align="center" label="申请金额">
                              <template slot-scope="scope">{{scope.row.eye_money | setNumFormat}}</template>
                            </el-table-column>
                          </el-table>
                        </span>
                      </el-col>
                    </el-row>

                    <!-- <el-row :gutter="20" justify="center" style="padding:10px 0px;">
                      <el-col :span="20">
                        <p class="box-title">提交的照片：</p>
                        <div
                          style="display:flex;padding:20px"
                          v-if="baseInfo.info.cardno_pic_url && baseInfo.info.cardno_pic_url.length > 0"
                        >
                          <span class="box-value" style="width:80px">身份证照片：</span>
                          <template v-for="item in baseInfo.info.cardno_pic_url">
                            <viewer :images="baseInfo.info.cardno_pic_url">
                              <img
                                :src="item.url"
                                alt
                                style="width: 100px; height: 100px;margin-right:15px;cursor: pointer;"
                              />
                            </viewer>
                          </template>
                        </div>

                        <div
                          style="display:flex;padding:20px"
                          v-if="baseInfo.info.household_pic_url && baseInfo.info.household_pic_url.length > 0"
                        >
                          <span class="box-value" style="width:80px">户主和本人：</span>
                          <template v-for="item in baseInfo.info.household_pic_url">
                            <viewer :images="baseInfo.info.household_pic_url">
                              <img
                                :src="item.url"
                                alt
                                style="width: 100px; height: 100px;margin-right:15px;cursor: pointer;"
                              />
                            </viewer>
                          </template>
                        </div>

                        <div v-for="item in baseInfo.pic" style="display:flex;padding:20px">
                          <template v-for="(val,key) in item">
                            <span
                              v-if="key == 0"
                              class="box-value"
                              style="width:80px"
                            >{{val.subtype_text}}：</span>
                            <viewer :images="item">
                              <img
                                :src="val.url"
                                alt
                                style="width: 100px; height: 100px;margin-right:15px;cursor: pointer;"
                              />
                            </viewer>
                          </template>
                        </div>
                      </el-col>
                    </el-row>-->
                    <!-- </el-collapse-item>
                    </el-collapse>-->
                  </div>
                </el-card>
              </el-tab-pane>
              <el-tab-pane label="救助记录" name="2">
                <el-table
                  :data="baseInfo.history"
                  v-if="baseInfo.history && baseInfo.history.length>0"
                  border
                >
                  <el-table-column prop="user_name" label="姓名" width="250" align="center"></el-table-column>
                  <el-table-column prop="project_name" label="申请项目" min-width="250" align="center"></el-table-column>
                  <el-table-column prop="apply_amount" label="申请金额" width="150" align="center"></el-table-column>
                  <el-table-column prop="regtime" width="150" label="申请时间" align="center"></el-table-column>
                  <el-table-column prop="audit_result_text" label="申请状态" width="100" align="center"></el-table-column>
                  <el-table-column prop="apply_status_text" label="拨款状态" width="100" align="center"></el-table-column>
                  <el-table-column width="100" label="操作" align="center">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        v-if="scope.row.apply_status || scope.row.apply_status === 0"
                        icon="el-icon-view"
                        style="padding: 5px 7px"
                        size="mini"
                        @click="getPaymentDetail(scope.row.pay_id,scope.row.project_id,scope.row.project_name)"
                      >拨款信息</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div v-else>
                  <p style="clear: both;font-size:14px;color:#666;">
                    <i class="el-icon-warning" size="18" style="clear: both;"></i>&nbsp;暂无其他救助申请记录~
                  </p>
                </div>
              </el-tab-pane>
              <el-tab-pane label="媒体报告" name="3">
                <el-table
                  v-if="baseInfo.media && baseInfo.media.length>0"
                  border
                  :data="baseInfo.media"
                  :row-key="row_key_media"
                  style="width: 100%"
                >
                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <el-form label-position="left" inline class="table-expand">
                        <el-form-item label="报道标题">
                          <span>{{props.row.title}}</span>
                        </el-form-item>
                        <el-form-item label="报道级别">
                          <span>{{ props.row.level_text }}</span>
                        </el-form-item>
                        <el-form-item label="报道类型">
                          <span>{{ props.row.type_text }}</span>
                        </el-form-item>

                        <el-form-item label="链接地址">
                          <span v-if="props.row.url">
                            <a
                              :href="props.row.url?props.row.url:'javascript:;'"
                              target="_blank"
                              style="text-decoration: underline; color: #333; cursor: pointer;color:#4682B4 "
                            >{{ props.row.url }}</a>
                          </span>
                        </el-form-item>
                        <el-form-item label="附件">
                          <!-- <span
                            @click="downFile(props.row.file, props.row.file_name)"
                            style="text-decoration: underline; color: #333; cursor: pointer;color:#4682B4 "
                          >{{ props.row.file_name }}</span>-->
                          <a
                            style="margin-right:8px;"
                            :href="props.row.file_url"
                            target="_blank"
                          >{{props.row.file_name}}</a>
                        </el-form-item>
                        <el-form-item label="报道说明">
                          <span>{{ props.row.description }}</span>
                        </el-form-item>
                        <el-form-item label="报道图片">
                          <viewer
                            :images="props.row.pic_url"
                            v-if=" props.row.pic_url && props.row.pic_url.length>0"
                          >
                            <img
                              v-for="(item,index) in props.row.pic_url"
                              :key="index"
                              :src="item.url"
                              style="width: 50px; height: 50px;cursor: pointer;margin-right:5px"
                            />
                            <p style="clear: both; padding-top: 10px">
                              <i class="el-icon-warning" size="18" style="clear: both;"></i>&nbsp;点击上方图片查看/下载大图
                            </p>
                          </viewer>
                        </el-form-item>
                      </el-form>
                    </template>
                  </el-table-column>
                  <el-table-column label="媒体报道标题" width="400" prop="title"></el-table-column>
                  <el-table-column label="报道级别" min-width="200" prop="level_text"></el-table-column>
                  <el-table-column label="添加时间" min-width="200" prop="addtime"></el-table-column>
                </el-table>
                <div v-else>
                  <p style="clear: both;font-size:14px;color:#666;">
                    <i class="el-icon-warning" size="18" style="clear: both;"></i>&nbsp;暂无数据
                  </p>
                </div>
              </el-tab-pane>
              <el-tab-pane label="回访记录" name="4">
                <el-table
                  v-if="baseInfo.visit && baseInfo.visit.length>0"
                  border
                  :data="baseInfo.visit"
                  style="width: 100%;"
                  class="tables"
                >
                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <el-form label-position="top">
                        <el-form-item label="具体回访内容" style="width:100%">
                          <div v-for="(item,index) in props.row.answer" :key="'answer'+index">
                            <p>
                              <span style="color:red">问：</span>
                              {{item.question_name}}
                            </p>
                            <div v-if="item.option_type == 2">
                              <span style="color:green">答：</span>
                              <span>{{item.option_item}}</span>
                            </div>

                            <div v-if="item.option_type == 1">
                              <span style="color:green">答：</span>
                              <span
                                v-if="item.option_item.find(val=>{return val.check==true})"
                              >{{item.option_item.find(val=>{return val.check==true}).input?item.option_item.find(val=>{return val.check==true}).input:item.option_item.find(val=>{return val.check==true}).value}}</span>
                              <span v-else>未填写信息~</span>
                            </div>
                          </div>
                        </el-form-item>
                      </el-form>
                    </template>
                  </el-table-column>
                  <el-table-column label="回访人" prop="visit_user" align="center"></el-table-column>
                  <el-table-column label="回访时间" prop="visit_time" align="center"></el-table-column>
                </el-table>
                <div v-else>
                  <p style="clear: both;font-size:14px;color:#666;">
                    <i class="el-icon-warning" size="18" style="clear: both;"></i>&nbsp;暂无数据
                  </p>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </el-card>
      <pay-detail
        v-if="if_open"
        v-model="if_open"
        :id="pay_id"
        :pid="project_id"
        :title="pay_title"
      ></pay-detail>

      <div class="drawer-footer">
        <el-button type="danger" size="small" icon="el-icon-close" @click="cancelBtn">关闭</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import payDetail from "../appropriation/detail";
export default {
  components: {
    payDetail,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "项目信息",
    },
    size: {
      type: [String, Number],
      default: "80%",
    },
    id: {
      type: [String, Number],
      default: null,
    },
  },

  data() {
    return {
      visible: false,
      activeName: "1",

      if_open: false, //拨款信息详情
      pay_id: null, //拨款信息id
      project_id: null, //项目id
      pay_title: {
        pro_name: null,
        user_name: null,
      },

      // collapseActive: "1",
      baseInfo: {
        info: {},
        extend: {},
        opinion: {},
        poor_files_path: [],
        eye: [],
      }, //基础信息
      apply_type_text: [], //申请人类型
      district: {},
      row_key_media: "",

      defaultImg: require("@/assets/images/news.png"),
      onerrorDefaultImg:
        'this.src="' + require("@/assets/images/news.png") + '"',
    };
  },
  methods: {
    cancelBtn() {
      this.visible = false;
    },

    //千分化金额
    setMoneyFormat(num) {
      if (num) {
        let value = typeof num === "number" ? num : Number(num);
        return (value.toFixed(2) + "").replace(
          /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
          "$&,"
        );
      }
    },

    //计算表格合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }

        if (index === 1) {
          return "";
        }

        const values = data.map((item) => Number(item.eye_money));

        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "";
        }
      });

      if (sums[2] > 0) {
        sums[2] = "总额：" + this.setMoneyFormat(sums[2]) + " 元";
      }

      return sums;
    },

    //获取拨款详情
    getPaymentDetail(id, pid, project_name) {
      this.pay_id = id;
      this.project_id = pid;
      this.pay_title.pro_name = project_name;
      this.pay_title.user_name = this.baseInfo.info.user_name;
      this.if_open = true;
    },

    //获取申请信息详情
    getDetails() {
      let loading = this.$loading({
        text: "数据正在加载中……",
      });
      this.$db
        .post(this.$db.config.cf_project.apply.info, {
          id: this.id,
        })
        .then((res) => {
          if (res && res.code == 200) {
            loading.close();
            this.baseInfo = res.data;
            this.apply_type_text = res.data.info.apply_type_text.join("、");
            this.district =
              (res.data.info.province_id_text
                ? res.data.info.province_id_text
                : "") +
              (res.data.info.city_id_text
                ? "/" + res.data.info.city_id_text
                : "") +
              (res.data.info.county_id_text
                ? "/" + res.data.info.county_id_text
                : "") +
              (res.data.info.address ? "   " + res.data.info.address : "");
          }
        });
    },

    downFile(id, name) {
      this.$db
        .downFilePost(this.$db.config.downloadFileUrl, { file_id: id })
        .then((res) => {
          if (res.hasOwnProperty("code")) {
            var enc = new TextDecoder("utf-8");
            var result = JSON.parse(enc.decode(new Uint8Array(res)));
            if (result.code !== 200) {
              this.$message.warning(result.msg);
            }
          } else {
            this.download(res, name);
          }
        });
    },
    // 下载文件
    download(data, name) {
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let alink = document.createElement("a");
      alink.href = url;
      alink.download = name; //文件名
      alink.click();
      this.downConfirm = false;
    },

    //千分化金额
    setMoneyFormat(num) {
      let value = typeof num === "number" ? num : Number(num);
      return (value.toFixed(2) + "").replace(
        /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
        "$&,"
      );
    },
  },
  watch: {
    visible(val) {
      this.$emit("input", val);
    },

    value: {
      handler(val) {
        this.visible = val;
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.id > 0) {
      this.getDetails();
    }
  },
};
</script>

<style lang="scss" scoped>
.box /deep/ .drawer1 {
  overflow: auto;
  .left {
    .avatar {
      display: flex;
      align-items: center;
      width: calc(100% - 50px);
      max-height: calc(100% - 50px);
      padding: 5px;
      margin-bottom: 20px;
      justify-content: center;
      border: 1px solid #ddd;
      img {
        border: 1px solid #ddd;
        border-radius: 3px;
        width: 100%;
        height: 100%;
      }
    }

    .left-bottom {
      p {
        padding: 5px;
        font-size: 0.8em;
        span {
          color: #999;
          font-size: 0.6em;
        }
      }
    }
  }

  .box-title {
    padding: 5px;
    font-size: 0.8em;
  }

  .box-value {
    color: #999;
    font-size: 0.6em;
  }

  .table-expand {
    font-size: 0;
  }
  .table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .table-expand-lable {
    width: 90px;
    color: #99a9bf;
  }
  .table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 48%;
  }

  .drawer-footer {
    width: 80%;
    position: fixed;
    bottom: 0;
    right: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/cfproject/apply/detail.vue